"use client"

import { Button } from "@/components/ui/button"

interface CtaScrollSectionProps {
  supertitle?: string | null
  heading?: string | null
  description?: string | null
  primaryButtonText?: string | null
  secondaryButtonText?: string | null
}

export function CtaScrollSection({
  supertitle,
  heading,
  description,
  primaryButtonText,
  secondaryButtonText,
}: CtaScrollSectionProps) {
  const scrollToContact = () => {
    document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" })
  }

  const scrollToServices = () => {
    document.querySelector("#services")?.scrollIntoView({ behavior: "smooth" })
  }

  return (
    <section className="py-24 bg-gradient-to-r from-pink-600 to-purple-600 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.1) 1px, transparent 1px),
                               linear-gradient(90deg, rgba(255, 255, 255, 0.1) 1px, transparent 1px)`,
            backgroundSize: "40px 40px",
          }}
        />
      </div>

      <div className="container mx-auto px-4 text-center text-brand-1 relative z-10">
        {supertitle && (
          <h2 className="text-sm font-semibold text-pink-200 tracking-wide uppercase mb-4 font-sans">
            {supertitle}
          </h2>
        )}
        {heading && <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-6">{heading}</h2>}
        {description && (
          <p className="text-base sm:text-lg lg:text-xl mb-8 max-w-2xl mx-auto opacity-90">
            {description}
          </p>
        )}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          {primaryButtonText && (
            <Button variant="default" size="xl" type="button" onClick={scrollToContact}>
              {primaryButtonText}
            </Button>
          )}
          {secondaryButtonText && (
            <Button variant="gradient-outline" size="xl" type="button" onClick={scrollToServices}>
              {secondaryButtonText}
            </Button>
          )}
        </div>
      </div>
    </section>
  )
}
